<template>
  <main-layout>
    <div class="contactDiv">
      <div class="container">
        <H1 class="pageTitle isPoppins">Contact</H1>
        <br>
  
  
              
      <div class="columns">
            <div class="column">
                  <div v-if="showForm">
                    <span class="has-text-white">Please fill out the form below to contact us. All fields are required.</span>
                  </div>
                  <div class="limitWidth top10">
                      <form class="form accSettingsForm" v-on:submit.prevent="submitForm" v-if="showForm">
                          <div class="field" :class="{formError: errors.first('fName') }">
                              First Name:*
                              <input type="text" class="input is-warning" name="fName"  v-validate="'required'" v-model="form.fName" />
                              <p class="help is-danger" >
                                  {{ errors.first('fName') }}
                              </p>
                          </div>
                          <div class="field" :class="{formError: errors.first('lName') }">
                              Last Name:*
                              <input type="text" class="input is-warning" name="lName" v-validate="'required'" v-model="form.lName"/>
                              <p class="help is-danger" >
                                  {{ errors.first('lName') }}
                              </p>
                          </div>
                          
                          <div class="field" :class="{formError: errors.first('Email') }">
                              Email:*
                              <input type="text" class="input is-warning" name="Email" v-validate="'required|email'" v-model="form.email" />
                              <p class="help is-danger" >
                                  {{ errors.first('Email') }}
                              </p>
                          </div>
                            <span style="color: #f5f5f5"><b>Category:*</b></span>
                           <div class="field select is-warning width100" :class="{formError: errors.first('Category')}">
                              
                                  <select name="Category" class="is-warning width100"  v-validate="'required'" v-model="form.category">
                                      <option disabled value="">Select...</option>
                                      <option value="billing">Billing</option>
                                      <option value="tech">Technical Support</option>
                                      <option value="custservice">Customer Service</option>
                                  </select>
                                   <p class="help is-danger" >
                                     {{ errors.first('Category') }}
                                  </p>
                          </div>
                          <br>
      
                           <div class="field" :class="{formError: errors.first('Message') }">
                              Message:*
                              <textarea type="text" class="textarea is-warning" name="Message" rows="5" v-validate="'required'" v-model="form.message"></textarea>
                              <p class="help is-danger" >
                                  {{ errors.first('Message') }}
                              </p>
                          </div>
                         
                         
                          <div class="field">
                              <div id="recaptcha-main" class="g-recaptcha" data-sitekey="6LdPJ7caAAAAABSJZ2-94XxGY_h_7Ux38kc1YfYc" data-theme="dark"></div>
                          </div>
      
                          <div class="field">
                              <button id="save" type="submit" class="button is-warning top10">SUBMIT</button>
                          </div>
                      </form>
      
                      <div v-if="!showForm" class="has-text-dark">
                          <div class="is-size-5">
                              Thank you!
                          </div>
                          <div class="top-40">
                              Your message has been sent. Our team will contact you shortly.
                          </div>
                      </div>
                  </div>
                
             </div>
               <div class="column is-hidden-mobile top40">
                    <!-- <img src="@/assets/img/contactIcon.png" class="top80" width="550" /> -->
              </div>
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'

export default {
  components: {
    MainLayout
  },
  data: function(){
    return {
      showForm: true,
      form: {
        fName: '',
        lName: '',
        email: '',
        message: '',
        category: '',
        sub: ''
      }
    }
  },
  mounted: function(){
    function configRecaptcha(){
      
    }
    

    this.$root.loadScript('https://www.google.com/recaptcha/api.js', configRecaptcha)

     setTimeout(() => {
        grecaptcha.render('recaptcha-main'); // 'recaptcha-main' is the id that was assigned to the widget
    }, 200);
  },
  
  methods: {
    submitForm: function () {
      var self = this

      this.$validator.validateAll().then(res => {
        if (res) {
          doReCaptcha()
        } else {
          self.$root.showModalOK({message: 'Please correct the errors or omissions on the form.'})
        }
      })

      function doReCaptcha(){
        
          let rc = grecaptcha.getResponse()

         if(rc == '' || rc == undefined){
          self.$root.showModalOK({message: "Please complete the - I'm not a Robot - verification."})
          return
         }
   
            

         function w(d){
           if(d.r == 'ok'){
             doRegistration()
           } else {
             self.$root.showModalOK({message: 'Robot Verification returned an error, please reload the page and try again.'})
           }
         }

         function n(){
           //
         }

         self.$root.apiClient.post('', {token: rc}, w, n)
      }

      function doRegistration () {

    
            az.addRemSpinner(true, 'id', 'save');
    
            function w(d){
              az.addRemSpinner(false, 'id', 'save');
              window.scrollTo(0,0)
              self.showForm = false
            } 
            
            function n(){
              az.addRemSpinner(false, 'id', 'save');
            }
            
            if(self.$root.isAuth){
              self.form.sub = self.$root.userAttrs.sub
            }
            self.$root.apiClient.post('ct', self.form, w, n)

      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Contact.vue